import React, {
  useState,
  useEffect,
  useReducer,
  useContext,
  useRef,
} from "react";

import { toast } from "react-toastify";
import { useParams, useHistory } from "react-router-dom";

import { useStyles } from "./ContactListItemsStyles";
import useContactListItems from "./useContactListItems";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import SearchIcon from "@material-ui/icons/Search";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";

import IconButton from "@material-ui/core/IconButton";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import BlockIcon from "@material-ui/icons/Block";

import api from "../../services/api";
import TableRowSkeleton from "../../components/TableRowSkeleton";
import ContactListItemModal from "../../components/ContactListItemModal";
import ConfirmationModal from "../../components/ConfirmationModal/";

import { i18n } from "../../translate/i18n";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import MainContainer from "../../components/MainContainer";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";
import { Can } from "../../components/Can";
import useContactLists from "../../hooks/useContactLists";
import useColumnAliases from "../../hooks/useColumnAliases";
import { Grid, Dialog, DialogTitle, DialogContent, DialogActions, Typography, CircularProgress, LinearProgress, Box } from "@material-ui/core";

import planilhaExemplo from "../../assets/planilha.xlsx";
import { SocketContext } from "../../context/Socket/SocketContext";



const ContactListItems = () => {
  const classes = useStyles();
  const {
    confirmOpen,
    contactList,
    contactListId,
    contactListItemModalOpen,
    contacts,
    deletingContact,
    dispatch,
    errorMessage,
    errorModalOpen,
    fileUploadRef,
    getAlias,
    goToCampaigns,
    goToContactLists,
    hadleEditContact,
    handleCloseContactListItemModal,
    handleDeleteContact,
    handleImportContacts,
    handleOpenContactListItemModal,
    handleScroll,
    handleSearch,
    hasMore,
    history,
    importProgress,
    importProgressModalOpen,
    loadMore,
    loading,
    pageNumber,
    searchParam,
    selectedContactId,
    setConfirmOpen,
    setContactList,
    setContactListItemModalOpen,
    setDeletingContact,
    setErrorMessage,
    setErrorModalOpen,
    setHasMore,
    setImportProgress,
    setImportProgressModalOpen,
    setLoading,
    setPageNumber,
    setSearchParam,
    setSelectedContactId,
    socketManager,
    user,
  } = useContactListItems();

  return (
    <MainContainer className={classes.mainContainer}>
      {/* ✅ CORRECCIÓN: Modal de error para mostrar mensajes de validación del backend */}
      <Dialog
        open={errorModalOpen}
        onClose={() => setErrorModalOpen(false)}
        aria-labelledby="error-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="error-dialog-title" style={{ color: "#d32f2f" }}>
          <span role="img" aria-label="Advertencia">⚠️</span> No se puede eliminar el contacto
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="body1" style={{ whiteSpace: "pre-line" }}>
            {errorMessage}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setErrorModalOpen(false)}
            color="default"
            variant="outlined"
          >
            Cerrar
          </Button>
          <Button
            onClick={goToCampaigns}
            color="primary"
            variant="contained"
          >
            Ir a Campañas
          </Button>
        </DialogActions>
      </Dialog>
      
      {/* ✅ PASO 2: Modal de progreso de importación */}
      <Dialog
        open={importProgressModalOpen}
        onClose={() => {}} // No permitir cerrar mientras está procesando
        aria-labelledby="import-progress-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="import-progress-dialog-title">
          Importando Contactos
        </DialogTitle>
        <DialogContent dividers>
          <Box display="flex" flexDirection="column" alignItems="center" p={2}>
            {/* ✅ MEJORA UX: Mostrar spinner solo si no está completo, check si está al 100% */}
            {importProgress.percentage < 100 ? (
              <CircularProgress size={60} thickness={4} style={{ marginBottom: 20 }} />
            ) : (
              <CheckCircleIcon 
                style={{ 
                  fontSize: 60, 
                  color: '#4caf50', 
                  marginBottom: 20 
                }} 
              />
            )}
            
            {/* ✅ PASO 2: Contador X/Y contactos */}
            <Typography variant="h6" style={{ marginBottom: 10, fontWeight: 'bold' }}>
              {importProgress.processed}/{importProgress.total} contactos
            </Typography>
            
            {/* ✅ PASO 2: Barra de progreso lineal */}
            <Box width="100%" style={{ marginBottom: 10 }}>
              <LinearProgress 
                variant="determinate" 
                value={importProgress.percentage} 
                style={{ 
                  height: 8, 
                  borderRadius: 4,
                  backgroundColor: importProgress.percentage === 100 ? '#4caf50' : undefined
                }}
              />
            </Box>
            
            {/* ✅ PASO 2: Porcentaje */}
            <Typography variant="body1" color="textSecondary">
              {importProgress.percentage}% completado
            </Typography>
            
            {/* ✅ PASO 2: Mensaje de estado */}
            {importProgress.message && (
              <Typography variant="body2" color="textSecondary" style={{ marginTop: 10, textAlign: 'center' }}>
                {importProgress.message}
              </Typography>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => setImportProgressModalOpen(false)} 
            color="primary"
            disabled={importProgress.percentage < 100}
          >
            {importProgress.percentage >= 100 ? "Cerrar" : "Cancelar"}
          </Button>
        </DialogActions>
      </Dialog>
      
      <ContactListItemModal
        open={contactListItemModalOpen}
        onClose={handleCloseContactListItemModal}
        aria-labelledby="form-dialog-title"
        contactId={selectedContactId}
      ></ContactListItemModal>
      <ConfirmationModal
        title={
          deletingContact
            ? `${i18n.t("contactListItems.confirmationModal.deleteTitle")} ${
                deletingContact.name
              }?`
            : `${i18n.t("contactListItems.confirmationModal.importTitle")}`
        }
        open={confirmOpen}
        onClose={(close) => {
          setConfirmOpen(close);
          if (close && deletingContact) {
            setDeletingContact(null);
          }
        }}
        onConfirm={() =>
          deletingContact
            ? handleDeleteContact(deletingContact.id)
            : handleImportContacts()
        }
      >
        {deletingContact ? (
          `${i18n.t("contactListItems.confirmationModal.deleteMessage")}`
        ) : (
          <>
            {i18n.t("contactListItems.confirmationModal.importMessage")}
            <a href={planilhaExemplo} download="planilha.xlsx">
              Haz clic aquí para descargar plantilla de ejemplo.
            </a>
          </>
        )}
      </ConfirmationModal>
      <MainHeader>
        <Grid style={{ width: "99.6%" }} container>
          <Grid xs={12} sm={5} item>
            <Title>{contactList.name}</Title>
          </Grid>
          <Grid xs={12} sm={7} item>
            <Grid spacing={2} container>
              <Grid xs={12} sm={6} item>
                <TextField
                  fullWidth
                  placeholder={i18n.t("contactListItems.searchPlaceholder")}
                  type="search"
                  value={searchParam}
                  onChange={handleSearch}
                  className={classes.searchField}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon style={{ color: "#1976d2" }} />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid xs={4} sm={2} item>
                <Button
                  fullWidth
                  variant="contained"
                  className={classes.primaryButton}
                  onClick={goToContactLists}
                >
                  {i18n.t("contactListItems.buttons.lists")}
                </Button>
              </Grid>
              <Grid xs={4} sm={2} item>
                <Button
                  fullWidth
                  variant="contained"
                  className={classes.primaryButton}
                  onClick={() => {
                    fileUploadRef.current.value = null;
                    fileUploadRef.current.click();
                  }}
                >
                  {i18n.t("contactListItems.buttons.import")}
                </Button>
              </Grid>
              <Grid xs={4} sm={2} item>
                <Button
                  fullWidth
                  variant="contained"
                  className={classes.primaryButton}
                  onClick={handleOpenContactListItemModal}
                >
                  {i18n.t("contactListItems.buttons.add")}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MainHeader>
      <Paper
        className={classes.mainPaper}
        variant="outlined"
        onScroll={handleScroll}
      >
        <>
          <input
            style={{ display: "none" }}
            id="upload"
            name="file"
            type="file"
            accept=".xls,.xlsx"
            onChange={() => {
              setConfirmOpen(true);
            }}
            ref={fileUploadRef}
          />
        </>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell align="center" style={{ width: "0%" }} className={classes.tableHeader}>
                #
              </TableCell>
              <TableCell className={classes.tableHeader}>{i18n.t("contactListItems.table.name")}</TableCell>
              <TableCell align="center" className={classes.tableHeader}>
                {i18n.t("contactListItems.table.number")}
              </TableCell>
              <TableCell align="center" className={classes.tableHeader}>
                {i18n.t("contactListItems.table.email")}
              </TableCell>
              <TableCell align="center" className={classes.tableHeader}>
                {getAlias("Columna 4")}
              </TableCell>
              <TableCell align="center" className={classes.tableHeader}>
                {getAlias("Columna 5")}
              </TableCell>
              <TableCell align="center" className={classes.tableHeader}>
                {getAlias("Columna 6")}
              </TableCell>
              <TableCell align="center" className={classes.tableHeader}>
                {i18n.t("contactListItems.table.actions")}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <>
              {contacts.map((contact) => (
                <TableRow key={contact.id}>
                  <TableCell align="center" style={{ width: "0%" }}>
                    <IconButton>
                      {contact.isWhatsappValid ? (
                        <CheckCircleIcon
                          titleAccess="Whatsapp Válido"
                          htmlColor="green"
                        />
                      ) : (
                        <BlockIcon
                          titleAccess="Whatsapp Inválido"
                          htmlColor="grey"
                        />
                      )}
                    </IconButton>
                  </TableCell>
                  <TableCell>{contact.name}</TableCell>
                  <TableCell align="center">{contact.number}</TableCell>
                  <TableCell align="center">{contact.email}</TableCell>
                  <TableCell align="center">{contact.colum4 != null && contact.colum4 !== '' ? String(contact.colum4) : '-'}</TableCell>
                  <TableCell align="center">{contact.colum5 != null && contact.colum5 !== '' ? String(contact.colum5) : '-'}</TableCell>
                  <TableCell align="center">{contact.colum6 != null && contact.colum6 !== '' ? String(contact.colum6) : '-'}</TableCell>
                  <TableCell align="center">
                    <IconButton
                      size="small"
                      onClick={() => hadleEditContact(contact.id)}
                      className={classes.actionIcon}
                      title="Editar Contacto"
                    >
                      <EditIcon />
                    </IconButton>
                    <Can
                      role={user.profile}
                      perform="contacts-page:deleteContact"
                      yes={() => (
                        <IconButton
                          size="small"
                          onClick={() => {
                            setConfirmOpen(true);
                            setDeletingContact(contact);
                          }}
                          className={classes.deleteIcon}
                          title="Eliminar Contacto"
                        >
                          <DeleteOutlineIcon />
                        </IconButton>
                      )}
                    />
                  </TableCell>
                </TableRow>
              ))}
              {loading && <TableRowSkeleton columns={4} />}
            </>
          </TableBody>
        </Table>
      </Paper>
    </MainContainer>
  );
};

export default ContactListItems;
